// Source: src/components/CloudAtCustomerSection.tsx. Values include intentional inline spacing.
const en = {
  "s1": "Your account, your boundary",
  "s2": "Control plane and every data plane inside your VPCs, IAM and KMS.",
  "s3": "Multi-cloud from one console",
  "s4": "EKS, GKE and AKS data planes managed by a single install.",
  "s5": "No static keys",
  "s6": "IRSA / Workload Identity for storage; your secret stores via external providers.",
  "s7": "Delivered as code",
  "s8": "Terraform in your repo, Helm from tagged, smoke-tested releases.",
  "s9": "In production with customers today",
  "s10": "GizmoData Cloud at Customer",
  "s11": "The same platform, installed inside your own AWS, Google Cloud or Azure accounts. Managed-service experience, with your data, credentials and network never leaving your boundary.",
  "s12": "Explore Cloud at Customer",
  "s13": "Talk to us about an install",
  "s14": "GizmoData sits outside your trust boundary — publishing signed releases and providing support, with no standing access to your data."
};
const pt: typeof en = {
  "s1": "Sua conta, seu perímetro",
  "s2": "Plano de controle e todos os planos de dados dentro das suas VPCs, IAM e KMS.",
  "s3": "Várias nuvens em um único console",
  "s4": "Planos de dados EKS, GKE e AKS gerenciados por uma única instalação.",
  "s5": "Sem chaves estáticas",
  "s6": "IRSA / Workload Identity para armazenamento; seus cofres de segredos por provedores externos.",
  "s7": "Entregue como código",
  "s8": "Terraform no seu repositório e Helm de versões identificadas por tags e validadas com testes básicos.",
  "s9": "Já em produção com clientes",
  "s10": "GizmoData Cloud at Customer",
  "s11": "A mesma plataforma, instalada nas suas próprias contas AWS, Google Cloud ou Azure. A experiência de um serviço gerenciado, com seus dados, credenciais e rede sempre dentro do seu perímetro.",
  "s12": "Conheça o Cloud at Customer",
  "s13": "Converse conosco sobre uma instalação",
  "s14": "A GizmoData fica fora do seu perímetro de confiança: publica versões assinadas e oferece suporte, sem acesso permanente aos seus dados."
};
export default { en, 'pt-BR': pt };
